import React,{useState} from 'react'
import './index.scss'
import { useNavigate } from 'react-router-dom'
import { done } from '../../../../../images/icon'
import { ANALYTICSEVENTS } from '../../Helpers/analyticsMap'
import pubsub from '@viewlift/pubsub'
import Cookies from 'js-cookie'
import axios from 'axios'
import { createAuthenticationSession } from '../../../../components/AdobeRestV2/Apis'

function TveDialogBox({providers,regCode,skipBtnText,ctaBackgroundColor,chooseProviderTxt, chooseProviderDescription,mvpdBgColor="#fff" }) {

    const navigate = useNavigate();
    const [chosenProvider,setChooseProvider] = useState('')
    let tveApiBaseUrl = window.app_data.appcmsPlatform.tveSettings.urlScheme
    let requestorID = window.app_data.appcmsPlatform.tveSettings.requestorID
    const adobeVersion = window?.app_data?.appcmsPlatform?.tveSettings?.version || "v1"

    const checkValidMvpd = (mvpd) => {
      for(let i = 0 ; i < providers.length; i++ ){
        if(mvpd.identifier == providers[i].ID || mvpd.identifier == providers[i].id){
          return true
        }
      }
      return false
    }

    const setSelectedprovider = (mvpdId) => {
      let domainName = window?.location?.host
        if (domainName.includes("www.")) {
          domainName = domainName.replace("www.","")
        }
        const data = new URLSearchParams();
        data.append('mvpd', mvpdId);
        data.append('domainName', domainName);
        if(regCode){
        const getTveAccessToken = Cookies.get("Tve_Access_token")
        let params = {
          requestor_id:requestorID,
          mso_id:mvpdId,
          reg_code:regCode,
          noflash:true ,
          domain_name :domainName,
          redirect_url:encodeURI(window?.location?.origin)
        }

        if(adobeVersion == "v1"){
          const searchParams = new URLSearchParams(params);
          window.open(`${tveApiBaseUrl}/api/v1/authenticate?${searchParams}`,"tvelogin","popup")
          navigate('/')
        }else{
        const URL = `${tveApiBaseUrl}/api/v2/${requestorID}/sessions/${regCode}`;
        data.append('redirectUrl', encodeURI(window?.location?.origin));
        return axios({
         method: 'post',
         url: URL,
         headers:{
           "Content-Type":"application/x-www-form-urlencoded",
           'Authorization': `Bearer ${getTveAccessToken}`
         },
        data: data
       })
        .then((res) => {
          if(res.data.actionName == "authenticate" && res.data.reasonType == "none"){
            const authenticationURL = res.data.url
            window.open(`${tveApiBaseUrl}${authenticationURL}`,"tvelogin","popup")
            navigate('/')
          }else if(res.data.actionName == "authorize" && res.data.reasonType == "authenticated"){
            navigate('/')
          }
          })
        .catch((error) => {
            if (error.response) {
              logger('Error Message GET Session TVE Dialog:'+ error.response?.data?.message,'info');
              logger('Error Code GET Session TVE Dialog:'+ error.response.status,'info');
              logger('Error Data GET Session TVE Dialog:'+ JSON.stringify(error.response.data), 'info');
            } else if (error.request) {
              logger('No response received GET Session TVE Dialog:'+ error.request,'info');
            } else {
              logger('Axios Error GET Session TVE Dialog:'+ error.message,'info');
            }
          })
        }
      } else {
        if(adobeVersion == "v1"){
          const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
          let tveInitEventData = {
            "pageUrl": checkoutInitPageDetails?.pageUrl,
            "mvpdProvider": mvpdId
          }
          setChooseProvider(mvpdId)
          window?.AE?.setSelectedProvider(mvpdId)
          let analyticsData={ename:ANALYTICSEVENTS.TVE_LOGIN_INITIATE,data: tveInitEventData};
          pubsub.publish('user-analytics',analyticsData)
        }else{
          localStorage.setItem('selectedMvpdId', mvpdId)
          data.append('redirectUrl', `${window?.location?.origin}${window.location.pathname}?isTveUser=Authenticated`);
          createAuthenticationSession(data)
        }
        
      }
    }

    let featuredProvider = window?.app_data?.appcmsPlatform?.tveSettings?.providers

  return (
    <div className='providersWrapper'>
        <div className={`providerList`}>
            {providers.length > 0 && featuredProvider?.map((item) => {
              let isValidMvpd = checkValidMvpd(item)
              if(isValidMvpd){
                return <div tabIndex={0}  className={ chosenProvider == item.identifier ? 'providerItem selected'  : `providerItem`} onClick={() => {setSelectedprovider(item.identifier)}} style={{backgroundColor:mvpdBgColor}}>
                        <div className={chosenProvider == item.identifier ? "tick tick-select" :"tick"}>{done()}</div>
                        <div style={{margin: 'auto'}}>
                            <img tabIndex={0} src={item.imageUrl} alt={item.title}/>
                        </div>
                    </div>

              }
            })}
            <div className='disable-overlay' id="tveProviderSecureWall"></div>
        </div>
    </div>
  )
}

export default TveDialogBox